import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'

const SharedSettingsStyleParts = ['wrapper'] as const

const helpers = createMultiStyleConfigHelpers(SharedSettingsStyleParts)

export const SharedSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    wrapper: {
      display: 'flex',
      padding: '2.5rem',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      gap: '1.25rem',
      overflowY: 'auto',
      backgroundColor: asChakraVariable('bg.subtle'),
    },
  },
})

export const useSharedSettingsStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(SharedSettingsStyle, props) as MultiStyleType<
    typeof SharedSettingsStyleParts
  >
}
